module.exports = __webpack_public_path__ + "img/erudio_cadeado.b5736e37.svg";